import { render, staticRenderFns } from "./gModel.vue?vue&type=template&id=c59e8f2e&scoped=true&"
import script from "./gModel.vue?vue&type=script&lang=js&"
export * from "./gModel.vue?vue&type=script&lang=js&"
import style0 from "./gModel.vue?vue&type=style&index=0&id=c59e8f2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e8f2e",
  null
  
)

export default component.exports